import React from 'react';

import { FormField, FormHelp, Label } from '@zillow/constellation-10';

import type { Section } from '../../../models/index';
import YesAndNo from '../../Widgets/YesAndNo';
import { ROAM_TOWING } from '../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function RoamTowing({ section, setSectionValues }: Props): JSX.Element {
  function onNoRoamTowing(): void {
    setSectionValues({
      [ROAM_TOWING.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesRoamTowing(): void {
    setSectionValues({
      [ROAM_TOWING.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  return (
    <>
      <FormField
        required
        label={<Label>Do you use roam towing services on your property?</Label>}
        control={
          <YesAndNo
            yesHandler={onYesRoamTowing}
            noHandler={onNoRoamTowing}
            yesActive={section.getFieldValue(ROAM_TOWING.FIELD_NAME.IS_ENABLED)}
          />
        }
        description={<FormHelp>Roam towing services seek and tow vehicles parked on private property</FormHelp>}
      />
    </>
  );
}
